import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledIcon,
  StyledSlide,
  StyledText,
  StyledGradientContainer,
  StyledSlideImg,
} from './styles'
import icon_carousel_right from '../../../images/icon_carousel_right_transparent_bg.svg'
import { CarouselWrapper } from '../../atoms/carouselWrapper'
import { ResponsiveImage } from '../../atoms/responsiveImage'
import { getPathNavigation } from '../../../utils/getWebsiteUrl'

const DesktopPMCarousel = (props) => {
  const { slides, maxItemsVisible, onPrevious, onNext, index } = props

  const { length } = slides

  return (
    <CarouselWrapper
      length={length}
      index={index}
      maxItemsVisible={maxItemsVisible}
      onNext={onNext}
      onPrevious={onPrevious}
    >
      {slides.map((slide, i) => (
        <StyledSlide key={`pm-child-${i}`} length={length} to={getPathNavigation(slide.link)}>
          <StyledSlideImg>
            <ResponsiveImage
              image={{
                ...slide.image,
                sizes: { medium_large: slide.image?.url },
              }}
              loading={i < 4 ? 'eager' : 'lazy'}
            />
          </StyledSlideImg>
          <StyledGradientContainer>
            <StyledIcon
              src={slide.icon?.image.url}
              alt={slide.icon?.image.alt || `${slide.text} image`}
              loading={i < 4 ? 'eager' : 'lazy'}
            />
            <StyledText>{slide.text}</StyledText>
            <img
              width={16}
              height={16}
              src={icon_carousel_right}
              className="pm-icon-right"
              alt="Confirm"
            />
          </StyledGradientContainer>
        </StyledSlide>
      ))}
    </CarouselWrapper>
  )
}

DesktopPMCarousel.defaultProps = {
  slides: [],
  maxItemsVisible: 4,
  onPrevious: () => {},
  onNext: () => {},
  index: 0,
}

DesktopPMCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
      icon: PropTypes.shape({
        image: PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
        }),
      }),
    })
  ).isRequired,
  maxItemsVisible: PropTypes.number,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  index: PropTypes.number,
}

export { DesktopPMCarousel }
